var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.988 5.07987C18.9956 5.27484 18.9981 5.46973 18.9981 5.6647C18.9981 11.5758 14.84 18.3998 7.2361 18.3998C4.90033 18.3998 2.7284 17.6554 0.898438 16.3881C1.22192 16.4235 1.55044 16.4502 1.884 16.4502C3.82067 16.4502 5.60443 15.7322 7.01933 14.5269C5.21037 14.5003 3.68289 13.1976 3.15608 11.4251C3.40898 11.4783 3.66942 11.505 3.93577 11.505C4.31134 11.505 4.67599 11.4519 5.02551 11.3455C3.13253 10.9379 1.70672 9.13001 1.70672 6.95876C1.70672 6.93218 1.70672 6.92326 1.70672 6.90554C2.26461 7.23344 2.90316 7.43717 3.58121 7.46375C2.47045 6.65729 1.74031 5.28368 1.74031 3.7328C1.74031 2.91747 1.94364 2.14642 2.30156 1.48176C4.3399 4.1936 7.38735 5.97493 10.8229 6.16103C10.7524 5.83313 10.7162 5.48759 10.7162 5.14197C10.7162 2.66941 12.5672 0.666504 14.8509 0.666504C16.0398 0.666504 17.1135 1.20718 17.8672 2.07567C18.8107 1.88071 19.6947 1.50852 20.4945 0.99451C20.1845 2.04025 19.53 2.91743 18.6746 3.46689C19.5115 3.36054 20.3097 3.12144 21.0499 2.76695C20.4945 3.66204 19.7955 4.45065 18.988 5.07987Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTw);
export default __webpack_public_path__ + "static/media/tw.af62c914.svg";
export { ForwardRef as ReactComponent };